// Sound Configuration
// Maps sound names to their corresponding file paths in the sounds folder

export interface SoundConfig {
    fileName: string;
    volume?: number;
    loop?: boolean;
    preload?: boolean;
}

export interface SoundConfigMap {
    [soundName: string]: SoundConfig;
}

// Sound configuration mapping
// Key: Sound name used in code
// Value: Configuration object with file details
export const SOUND_CONFIG: SoundConfigMap = {
    // Default click sound for all button interactions
    'click': {
        fileName: 'click_sound.mp3',
        volume: 0.7,
        loop: false,
        preload: true
    },
    'money_up': {
        fileName: 'money_up.wav',
        volume: 0.75,
        loop: false,
        preload: true
    },
    'money_down': {
        fileName: 'money_down.wav',
        volume: 0.75,
        loop: false,
        preload: true
    }
};

// Default configuration for sounds not found in config
export const DEFAULT_SOUND_CONFIG: SoundConfig = {
    fileName: 'click_sound.mp3',
    volume: 0.7,
    loop: false,
    preload: true
};

// Sound names constants for type safety
export const SOUND_NAMES = {
    CLICK: 'click',
    MONEY_UP: 'money_up',
    MONEY_DOWN: 'money_down',
} as const;

export type SoundName = typeof SOUND_NAMES[keyof typeof SOUND_NAMES];

